import { useEffect, useState } from 'react';
import { getUploadLimits, peekUploadLimits } from '../utils/uploadToR2';

/** Envío AP-2 · límites de subida del usuario (null mientras no se conocen). */
export function useUploadLimits() {
  const [limits, setLimits] = useState(() => peekUploadLimits());
  useEffect(() => {
    let alive = true;
    getUploadLimits().then((value) => { if (alive && value) setLimits(value); });
    return () => { alive = false; };
  }, []);
  return limits;
}
